import { IResellerInfo, IResellerQualification, ISalesStatistics } from "../../api/reseller/ResellersApi";
import { OrderDetail } from "../document/Document";
import { SalesData } from "../manufacturer/Manufacturer";
import { Opportunity } from "../opportunities/Opportunity";
import Return from "../return/Return";

export default class Reseller {
  arEmail?: string;
  address1?: string;
  address2?: string;
  autoUpdate?: boolean;
  city?: string;
  contactName?: string;
  createdDate?: number;
  creditLimit?: number;
  defaultWarehouse?: string;
  defaultLeadTime?: string;
  defaultMaxInventoryValue?: string;
  defaultMinimumOrder?: string;
  defaultWeeksOfStocking?: string;
  domain?: string;
  googleEmail?: string;
  resellerId?: string;
  name?: string;
  pOEmail?: string;
  phone?: string;
  postalCode?: string;
  province?: string;
  country?: string;
  publicName?: string;
  publicEmail?: string;
  shopifyWebsite?: string;
  terms?: string
  website?: string;
  priority?: string;
  shippingProfile?: string;
  priceProfile?: number;
  isQualified?: boolean;
  onHold?: number;
  creationDate?: number;
  lastInvoiceDate?: number;
  salesData?: SalesData;
  activeOrderDetails?: OrderDetail[];
  completedOrderDetails?: OrderDetail[];

  constructor(source?: IResellerInfo) {
    if (source) {
      this.arEmail = source.AREmail;
      this.address1 = source.Address1;
      this.address2 = source.Address2;
      this.autoUpdate = source.AutoUpdate;
      this.city = source.City;
      this.contactName = source.ContactName;
      this.country = source.Country;
      this.createdDate = source.CreationDate;
      this.creditLimit = source.CreditLimit;
      this.defaultWarehouse = source.DefaultWarehouse;
      this.defaultLeadTime = source.DefaultLeadTime;
      this.defaultMaxInventoryValue = source.DefaultMaxInventoryValue;
      this.defaultMinimumOrder = source.DefaultMinimumOrder;
      this.defaultWeeksOfStocking = source.DefaultWeeksOfStocking;
      this.domain = source.Domain;
      this.googleEmail = source.GoogleEmail;
      this.resellerId = source.ResellerId;
      this.name = source.Name;
      this.pOEmail = source.POEmail;
      this.phone = source.Phone;
      this.postalCode = source.PostalCode;
      this.province = source.Province;
      this.publicName = source.PublicName || source.Name;
      this.publicEmail = source.PublicEmail;
      this.shopifyWebsite = source.ShopifyWebsite;
      this.terms = source.Terms;
      this.website = source.Website;
      this.priority = source.Priority;
      this.shippingProfile = source.ShippingProfile;
      this.priceProfile = source.PriceProfile;
      this.isQualified = source.IsQualified;
      this.onHold = source.OnHold
      this.creationDate = source.CreationDate;
      this.lastInvoiceDate = source.LastInvoiceDate;

      if (source.Qualifications)
        this.qualifications = source.Qualifications.map((q) => new ResellerQualification(q));

      if (source.Returns)
        this.returns = source.Returns.map(Return.convertFrom);

      if (source.Opportunities)
        this.opportunities = source.Opportunities.map(Opportunity.convertFrom);

      if (source.SalesData)
        this.salesData = SalesData.convertFrom(source.SalesData);

      if (source.ActiveOrderDetails)
        this.activeOrderDetails = source.ActiveOrderDetails.map(OrderDetail.convertFrom);

      if (source.CompletedOrderDetails)
        this.completedOrderDetails = source.CompletedOrderDetails.map(OrderDetail.convertFrom);
    }
  }

  /**
   * @deprecated Use the `priceProfileLetter` getter instead.
   */
  public PriceProfile(): string {
    return this.priceProfileLetter;
  }

  public get priceProfileLetter(): string {
    return String.fromCharCode((this.priceProfile || 3) + 64);
  }

  public qualifications?: ResellerQualification[];
  public returns?: Return[];
  public opportunities?: Opportunity[];

  public static convertFrom(source: IResellerInfo): Reseller {
    return new Reseller(source);
  }
}

export class ResellerQualification {
  manufacturerId?: string;
  qualificationId?: string;
  manufacturerPublicName?: string;

  constructor(source: IResellerQualification) {
    this.manufacturerId = source.ManufacturerId;
    this.qualificationId = source.QualificationId;
    this.manufacturerPublicName = source.ManufacturerPublicName;
  }
}

export class SalesStatistics {
  day?: number;
  quantity?: number;
  extendedPrice?: number;

  public static convertFrom(source: ISalesStatistics): SalesStatistics {
    const salesStatistics = new SalesStatistics();

    salesStatistics.day = source.Day;
    salesStatistics.quantity = source.Quantity;
    salesStatistics.extendedPrice = source.ExtendedPrice;

    return salesStatistics;
  }
}
